import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { isNorwegian } from '../../constants/languages';
import { getTranslation } from '../../constants/languages';

type EmailOtherButtonProps = {
  iimclient: ConfigClientType;
  linkUrl?: string;
};

const Translations = {
  lang_no: 'Andre henvendelser',
  lang_se: '', // Swedish was missing,
  lang_fi: 'Muut tiedustelut',
  lang_dk: 'Andre henvendelser', // Check this DK functionality in some other ticket
  lang_en: 'Other requests',
}

// No page exceptions found so far
const PageExceptions = {}

const EmailOtherButton = ({ iimclient, linkUrl }: EmailOtherButtonProps) => {
  const { lang, segment, texts } = iimclient;

  const segmentLink = segment && segment.floater_email_otherurl && segment.floater_email_otherurllabel;
  const hideLink = !(linkUrl || segmentLink || isNorwegian(iimclient));

  const translation = [
    segmentLink && segment.floater_email_otherurllabel,
    getTranslation(lang, Translations)
  ].reduce((a, b) => a || b);

  const link = [
    linkUrl,
    segmentLink && segment.floater_email_otherurl,
    'https://www.if.no/privat/kundeservice/skriv-til-oss/omforsikring'
  ].reduce((a, b) => a || b)

  const clickEmailOtherButton = () =>
    (window as any).NordicTracking.eventOtherLink(
      false,
      (window as any).NordicTracking.PANELINFO_FUNCTION_NAME_EMAIL,
      link
    );

  return !hideLink && (
    <div>
      <a
        href={link}
        className="if button secondary same-width"
        target="_blank"
        rel="noopener noreferrer"
        id="email-other-button"
        role="button"
        onClick={clickEmailOtherButton}>
        {translation}
      </a>
    </div>
  );
};

export default EmailOtherButton;
